import React from 'react';
import { Hidden } from '@material-ui/core';
import Button from '@cpg-its/ads.common.button';
import { useDispatch } from 'react-redux';
import { useCompensationSetting } from './use-compensation-setting';
import { usePagination } from '../shared-slices/usePagination';
import { goToPage } from '../shared-slices/pagination-slice';

import { paginationStyles } from '../../../global/constants/theme/styles/components/pagination';


interface PaginationProps {
    name: string,
    totalPages: number,
}

export const Pagination = (props: PaginationProps) => {
    const dispatch = useDispatch();
    const settings = useCompensationSetting();
    const classes = paginationStyles();

    const pagination = usePagination(props.name, props.totalPages, 1);

    if (!pagination) {
        return null;
    }

    const next = () => {
        dispatch(goToPage(pagination.currentPage + 1, pagination.name));
    };

    const prev = () => {
        dispatch(goToPage(pagination.currentPage - 1, pagination.name));
    };

    const hidePagination = pagination.lastPage <= 1;

    return (
        <>
            {
                !hidePagination ?
                    <div className={classes.paginationContainer}>
                        <div className='pagination-inner'>
                            <Button icon='back' type='button' text={settings.prevButton} buttonStyle='secondary' disabled={pagination.currentPage === pagination.firstPage} onClick={prev} />
                            <div className='pagination-text'>
                                <Hidden smUp>
                                   {/* Mobile*/}
                                    <p>{`${pagination.currentPage} of ${pagination.lastPage}`} </p>
                                </Hidden>
                                <Hidden xsDown>
                                   {/* Desktop*/}
                                    <p>{pagination.currentPage === pagination.lastPage ?
                                        `${pagination.currentPage} of ${pagination.lastPage}` :
                                        `${pagination.currentPage} - ${pagination.currentPage + 1} of ${pagination.lastPage}`}
                                    </p>
                                </Hidden>
                            </div>

                            < Button rightIcon icon='forward' type='button' text={settings.nextButton} buttonStyle='secondary' disabled={pagination.currentPage === pagination.lastPage} onClick={next} />
                        </div>
                    </div>
                    : null
            }
        </>
    );
};
